"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEDULING_REQUEST_EXAMPLES = exports.appointmentExpiryRequestSchema = exports.confirmAppointmentRequestSchema = exports.cancelAppointmentRequestSchema = exports.rescheduleAppointmentRequestSchema = void 0;
/**
 * Request contracts for the 4 Scheduling endpoints. Field shapes
 * mirror `SchedulingApplicationService`'s own method input shapes
 * (backend, frozen, Stage 5B.4).
 */
const zod_1 = require("zod");
exports.rescheduleAppointmentRequestSchema = zod_1.z.object({
    appointmentId: zod_1.z.string().uuid(),
    newScheduledAt: zod_1.z.coerce.date(),
    newDoctorId: zod_1.z.string().uuid().optional(),
    reasonCode: zod_1.z.string().max(100).optional(),
    reasonDescription: zod_1.z.string().optional(),
    rescheduledBy: zod_1.z.string().uuid().optional(),
});
const activeHoldSchema = zod_1.z.object({
    holdId: zod_1.z.string().uuid(),
    holdToken: zod_1.z.string().min(1),
});
exports.cancelAppointmentRequestSchema = zod_1.z.object({
    appointmentId: zod_1.z.string().uuid(),
    reasonCode: zod_1.z.string().max(100).optional(),
    reasonDescription: zod_1.z.string().optional(),
    refundApplicable: zod_1.z.boolean().optional(),
    refundPaymentId: zod_1.z.string().uuid().optional(),
    cancelledBy: zod_1.z.string().uuid().optional(),
    /** Only released if the caller already knows an active hold exists — see `docs/APPOINTMENT-APPLICATION-ARCHITECTURE.md` §6. */
    activeHold: activeHoldSchema.optional(),
    pendingReminderIds: zod_1.z.array(zod_1.z.string().uuid()).optional(),
});
exports.confirmAppointmentRequestSchema = zod_1.z.object({
    appointmentId: zod_1.z.string().uuid(),
});
/** An operational sweep, not a per-appointment action — `asOf` defaults to "now" if omitted, matching `AppointmentExpiryService.execute()`'s own default. */
exports.appointmentExpiryRequestSchema = zod_1.z.object({
    asOf: zod_1.z.coerce.date().optional(),
});
exports.SCHEDULING_REQUEST_EXAMPLES = {
    rescheduleAppointment: {
        appointmentId: '10000000-0000-0000-0000-000000000001',
        newScheduledAt: new Date('2026-08-02T11:00:00Z'),
        reasonCode: 'PATIENT_REQUEST',
    },
    cancelAppointment: {
        appointmentId: '10000000-0000-0000-0000-000000000001',
        reasonCode: 'PATIENT_REQUEST',
    },
    confirmAppointment: {
        appointmentId: '10000000-0000-0000-0000-000000000001',
    },
    appointmentExpiry: {},
};
//# sourceMappingURL=scheduling.request.js.map